/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserResponse } from '../../models/user-response';

export interface IdentityControllerGetAll$Params {
  roles?: Array<number>;
  query?: string;
  active?: boolean;
  isTechnician?: boolean;
  registry_id?: number;
  limit: number;
  skip: number;
  order_by?: string;
  order_direction?: string;
}

export function identityControllerGetAll(http: HttpClient, rootUrl: string, params: IdentityControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('roles', params.roles, {});
    rb.query('query', params.query, {});
    rb.query('active', params.active, {});
    rb.query('isTechnician', params.isTechnician, {});
    rb.query('registry_id', params.registry_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserResponse;
      }>;
    })
  );
}

identityControllerGetAll.PATH = '/identity';
